/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  AdminCopyTemplateToBuilderRequest,
  AdminTemplateListResponse,
  AdminTemplatesGetV2Params,
  CopyTemplateToOrgsRequest,
  CreateTemplateAdminRequest,
  CreateTemplateAdminResponse,
  JobImportActionRequiredResponse,
  OrgToOrgCopyResponse,
  TemplatesActionrequiredGetV2Params,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const templatesActionrequiredGetV2 = (
  params?: TemplatesActionrequiredGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<JobImportActionRequiredResponse>(
    { url: `/apix/v2/Templates/actionrequired`, method: "GET", params, signal },
    options,
  );
};

export const getTemplatesActionrequiredGetV2QueryKey = (
  params?: TemplatesActionrequiredGetV2Params,
) => {
  return [
    `/apix/v2/Templates/actionrequired`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTemplatesActionrequiredGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof templatesActionrequiredGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TemplatesActionrequiredGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof templatesActionrequiredGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTemplatesActionrequiredGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof templatesActionrequiredGetV2>>
  > = ({ signal }) =>
    templatesActionrequiredGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof templatesActionrequiredGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TemplatesActionrequiredGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof templatesActionrequiredGetV2>>
>;
export type TemplatesActionrequiredGetV2QueryError = ErrorType<unknown>;

export function useTemplatesActionrequiredGetV2<
  TData = Awaited<ReturnType<typeof templatesActionrequiredGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TemplatesActionrequiredGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof templatesActionrequiredGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTemplatesActionrequiredGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const templatesOrgToOrgCopyPostV2 = (
  copyTemplateToOrgsRequest: BodyType<CopyTemplateToOrgsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<OrgToOrgCopyResponse>(
    {
      url: `/apix/v2/Templates/org-to-org-copy`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: copyTemplateToOrgsRequest,
      signal,
    },
    options,
  );
};

export const getTemplatesOrgToOrgCopyPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templatesOrgToOrgCopyPostV2>>,
    TError,
    { data: BodyType<CopyTemplateToOrgsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templatesOrgToOrgCopyPostV2>>,
  TError,
  { data: BodyType<CopyTemplateToOrgsRequest> },
  TContext
> => {
  const mutationKey = ["templatesOrgToOrgCopyPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templatesOrgToOrgCopyPostV2>>,
    { data: BodyType<CopyTemplateToOrgsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return templatesOrgToOrgCopyPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplatesOrgToOrgCopyPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof templatesOrgToOrgCopyPostV2>>
>;
export type TemplatesOrgToOrgCopyPostV2MutationBody =
  BodyType<CopyTemplateToOrgsRequest>;
export type TemplatesOrgToOrgCopyPostV2MutationError = ErrorType<unknown>;

export const useTemplatesOrgToOrgCopyPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templatesOrgToOrgCopyPostV2>>,
    TError,
    { data: BodyType<CopyTemplateToOrgsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof templatesOrgToOrgCopyPostV2>>,
  TError,
  { data: BodyType<CopyTemplateToOrgsRequest> },
  TContext
> => {
  const mutationOptions =
    getTemplatesOrgToOrgCopyPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminTemplatesPostV2 = (
  createTemplateAdminRequest: BodyType<CreateTemplateAdminRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<CreateTemplateAdminResponse>(
    {
      url: `/apix/v2/admin/Templates`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: createTemplateAdminRequest,
      signal,
    },
    options,
  );
};

export const getAdminTemplatesPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminTemplatesPostV2>>,
    TError,
    { data: BodyType<CreateTemplateAdminRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminTemplatesPostV2>>,
  TError,
  { data: BodyType<CreateTemplateAdminRequest> },
  TContext
> => {
  const mutationKey = ["adminTemplatesPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminTemplatesPostV2>>,
    { data: BodyType<CreateTemplateAdminRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminTemplatesPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTemplatesPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminTemplatesPostV2>>
>;
export type AdminTemplatesPostV2MutationBody =
  BodyType<CreateTemplateAdminRequest>;
export type AdminTemplatesPostV2MutationError = ErrorType<unknown>;

export const useAdminTemplatesPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminTemplatesPostV2>>,
    TError,
    { data: BodyType<CreateTemplateAdminRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminTemplatesPostV2>>,
  TError,
  { data: BodyType<CreateTemplateAdminRequest> },
  TContext
> => {
  const mutationOptions = getAdminTemplatesPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminTemplatesGetV2 = (
  params?: AdminTemplatesGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AdminTemplateListResponse>(
    { url: `/apix/v2/admin/Templates`, method: "GET", params, signal },
    options,
  );
};

export const getAdminTemplatesGetV2QueryKey = (
  params?: AdminTemplatesGetV2Params,
) => {
  return [`/apix/v2/admin/Templates`, ...(params ? [params] : [])] as const;
};

export const getAdminTemplatesGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminTemplatesGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminTemplatesGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminTemplatesGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminTemplatesGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminTemplatesGetV2>>
  > = ({ signal }) => adminTemplatesGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminTemplatesGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminTemplatesGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminTemplatesGetV2>>
>;
export type AdminTemplatesGetV2QueryError = ErrorType<unknown>;

export function useAdminTemplatesGetV2<
  TData = Awaited<ReturnType<typeof adminTemplatesGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminTemplatesGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminTemplatesGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminTemplatesGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminTemplatesCopyToBuilderByTemplateIdPostV2 = (
  templateId: number,
  adminCopyTemplateToBuilderRequest: BodyType<AdminCopyTemplateToBuilderRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<OrgToOrgCopyResponse>(
    {
      url: `/apix/v2/admin/Templates/${templateId}/copy-to-builder`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: adminCopyTemplateToBuilderRequest,
      signal,
    },
    options,
  );
};

export const getAdminTemplatesCopyToBuilderByTemplateIdPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminTemplatesCopyToBuilderByTemplateIdPostV2>>,
    TError,
    { templateId: number; data: BodyType<AdminCopyTemplateToBuilderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminTemplatesCopyToBuilderByTemplateIdPostV2>>,
  TError,
  { templateId: number; data: BodyType<AdminCopyTemplateToBuilderRequest> },
  TContext
> => {
  const mutationKey = ["adminTemplatesCopyToBuilderByTemplateIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminTemplatesCopyToBuilderByTemplateIdPostV2>>,
    { templateId: number; data: BodyType<AdminCopyTemplateToBuilderRequest> }
  > = (props) => {
    const { templateId, data } = props ?? {};

    return adminTemplatesCopyToBuilderByTemplateIdPostV2(
      templateId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTemplatesCopyToBuilderByTemplateIdPostV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof adminTemplatesCopyToBuilderByTemplateIdPostV2>>
  >;
export type AdminTemplatesCopyToBuilderByTemplateIdPostV2MutationBody =
  BodyType<AdminCopyTemplateToBuilderRequest>;
export type AdminTemplatesCopyToBuilderByTemplateIdPostV2MutationError =
  ErrorType<unknown>;

export const useAdminTemplatesCopyToBuilderByTemplateIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminTemplatesCopyToBuilderByTemplateIdPostV2>>,
    TError,
    { templateId: number; data: BodyType<AdminCopyTemplateToBuilderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminTemplatesCopyToBuilderByTemplateIdPostV2>>,
  TError,
  { templateId: number; data: BodyType<AdminCopyTemplateToBuilderRequest> },
  TContext
> => {
  const mutationOptions =
    getAdminTemplatesCopyToBuilderByTemplateIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
